<script setup>
   import { useEnvironment } from '@/config'
   const environment = useEnvironment()

</script>

<template>
	<div v-if="environment == 'development'" class="test-wrapper">
		<slot></slot>
	</div>
</template>

<style lang="scss">
	.test-wrapper {
		display: flex;
		position: fixed;
		bottom: 50px;
		left: 20px;
		gap: 5px;
		z-index: 99999999;

		.trigger-test {
			position: static !important;
		}
	}
</style>